import Link from 'next/link';
import { AnchorHTMLAttributes, MouseEventHandler } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron.svg';

import { styles } from './PaginationArrow.styles';

interface PaginationArrowProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  direction: 'left' | 'right';
  href: string;
  disabled?: boolean;
  disabledNavigation?: boolean;
}

export function PaginationArrow({
  direction,
  disabled,
  href,
  disabledNavigation,
  onClick,
  ...props
}: PaginationArrowProps) {
  const slots = styles();

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabledNavigation) {
      event.preventDefault();
    }

    onClick?.(event);
  };

  return (
    <Link
      className={slots.base({ disabled, left: direction === 'left' })}
      href={href}
      onClick={handleClick}
      {...props}
    >
      <div className={slots.icon()}>
        <ChevronIcon className={slots.arrow()} />
      </div>
    </Link>
  );
}
